import React from "react";
import API from "../../../services/api.jsx";
import Loader from "../../layout/loader.jsx";
import Table from "../../layout/table.jsx";
import SmartPlayTag from "../../layout/SmartPlayTag/index.jsx";
import Helpers from "../../../services/helpers.jsx";
import moment from "moment";
import { toast } from "react-toastify";
import { debounce } from "lodash";

class CampaignsList extends React.Component {
  constructor(props) {
    super(props);
    let that = this;


    const columns = [
      {
        label: "Campaign name",
        key: "name",
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
        view: (field, entity) => {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>{field}</div>
              {entity?.hasSmartPlay && <SmartPlayTag marginLeft={6} />}
            </div>
          );
        },
      },
      {
        label: "Duration",
        key: "infinite",
        view: (field, entity) => {
          return field === true
            ? "Infinite"
            : moment(entity.startDate).format("L") +
                " - " +
                moment(entity.endDate).format("L");
        },
      },
      {
        label: "Status",
        key: "status",
        view: (field) => {
          return (
            <div
              style={{
                color: Helpers.CAMPAIGN_STATUS_MAP[field]?.labelColor,
              }}
            >
              {Helpers.CAMPAIGN_STATUS_MAP[field]?.label}
            </div>
          );
        },
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: "Devices",
        key: "devices",
        view: function (field) {
          return field.length;
        },
      },
      {
        label: "Priority",
        key: "priority",
      },
      {
        label: "Last update",
        key: "lastUpdatedAt",
        view: function (field) {
          if (field) {
            return moment(field).format("l");
          }
          return "-";
        },
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: "Update by",
        key: "nextUpdateBy",
        view: function (field) {
          if (field) {
            const value = moment(field).format("l");
            const passed = moment(field).isSameOrBefore(moment());
            return passed ? <div className="red">{value}</div> : value;
          }
          return "-";
        },
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
    ];
    if (Helpers.checkPermissions("campaigns:delete")) {
      columns.push({
        action: "delete",
        onClick: (id, key) => {
          var r = window.confirm(
            "Are you sure you want to delete this campaign?"
          );
          if (r === false) return;

          this.setState({ loading: true });
          API.delete("campaigns", id)
            .then(() => {
              toast.success("Campaign was successfully deleted");
              this.loadEntities();
            })
            .catch(() => {
              // toast.error("An unexpected error has occurred");
              this.setState({ loading: false });
            });
        },
      });
    }

    const actions = [];
    if (Helpers.checkPermissions("campaigns:edit")) {
      columns.push({
        action: 'copy',
        onClick: (id) => {
          window.open(
            `/clients/${props.match.params.clientId}/campaigns/new?copyFrom=${id}`
          );
        },
      });
      actions.push({
        classList: "blue add",
        label: "New campaign",
        onClick: () => {
          this.props.history.push(
            "/clients/" + props.match.params.clientId + "/campaigns/new"
          );
        },
      });
    }

    this.state = {
      loading: true,
      filters: {
        client: this.props.match.params.clientId,
      },
      sort: ["updatedAt", "DESC"],
      campaigns: {
        columns,
        entities: [],
        filters: [
          {
            label: "Search for a campaign",
            onChange: debounce((value) => {
              if (value !== this.state.filters.name)
                this.setState(
                  {
                    filters: {
                      ...this.state.filters,
                      name: value ? "/" + value + "/i" : "",
                    },
                  },
                  () => {
                    this.loadEntities();
                  }
                );
            }, 500),
          },
        ],
        actions,
        selectedItems: [],
        multiSelect: false,
        onRowClick: function (entity) {
          if (
            Helpers.checkPermissions(
              ["campaigns:details", "campaigns:edit"],
              true
            )
          ) {
            that.props.history.push(
              "/clients/" +
                props.match.params.clientId +
                "/campaigns/" +
                entity.id
            );
          }
        },
      },
    };
  }

  componentDidMount() {
    this.loadEntities();
  }

  onSort(key) {
    const newSort =
      this.state?.sort?.[0] === key
        ? this.state?.sort?.[1] === "ASC"
          ? [key, "DESC"]
          : [key, "ASC"]
        : [key, "ASC"];
    this.setState(
      {
        sort: newSort,
      },
      () => {
        this.loadEntities();
      }
    );
  }

  loadEntities() {
    API.getCampaigns(this.state.filters, this.state.sort).then((entities) => {
      const filters = [];
      if (entities?.filters?.availableFilters) {
        const filtersNames = ["name", "status", "hasSmartPlay"];
        entities.filters.availableFilters =
          entities.filters.availableFilters.filter((filter) =>
            filtersNames.includes(filter.name)
          );
        Helpers.handleFilters(this, filters, entities);
      }

      this.setState({
        ...this.state,
        loading: false,
        campaigns: {
          ...this.state.campaigns,
          filters,
          entities: entities?.data || [],
        },
      });
    });
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return (
        <>
          <Table settings={this.state.campaigns} sort={this.state.sort} />
        </>
      );
  }
}

export default CampaignsList;
